import styled from 'styled-components';

export const Slider = styled.div`
  color: #fb7e4d;
  max-width: 500px;
  display: inline-block;
  width: 100%;
`;
